// extracted by mini-css-extract-plugin
export default {"charts":"Charts_charts__zm-Yj","card":"Charts_card__bwZlt"};